import { render } from "./CanTho.vue?vue&type=template&id=59219eea&scoped=true"
import script from "./CanTho.vue?vue&type=script&lang=js"
export * from "./CanTho.vue?vue&type=script&lang=js"

import "./CanTho.vue?vue&type=style&index=0&id=59219eea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59219eea"]])

export default __exports__